export const LINEAGE_NONE = 'NONE';
export const LINEAGE_TYPE_1 = 'TYPE_1';
export const LINEAGE_TYPE_2 = 'TYPE_2';
export const LINEAGE_DICATANDO = 'DICTANDO';
export const LINEAGE_MATH = 'MATH';
export const LINEAGE_MUSIC = 'MUSIC';
export const LINEAGE_MM = 'MM';
